import { WorkflowFormTemplateStateEnum } from '@/models/workflow-form-template';
import {
  WorkflowFormSubmission,
  WorkflowFormSubmissionComment
} from '../workflow-form';
import {
  IWorkflowFormSubmission,
  IWorkflowFormSubmissionComment,
  IWorkflowFormSubmissionCommentData,
  IWorkflowFormSubmissionData
} from '../workflow-form.types';

export const mockWorkflowFormSubmissionCommentsData = (): IWorkflowFormSubmissionCommentData[] => [
  {
    id: 17,
    owner: 'Lamar Falconer',
    text:
      '<p>test data @uid:39  @uid:3  @uid:51 @uid:39 </p><p><br></p><p>test data @uid:39 </p><p><br></p><p>over here</p>',
    created_at: '2023-11-01T18:19:39.729729Z',
    updated_at: '2023-11-01T20:48:35.177459Z',
    mentions: [
      {
        id: 3,
        first_name: 'Brandon',
        last_name: 'Puim',
        email: 'bpuim@altoleap.com',
        employee: {
          id: 157,
          first_name: 'Brandon',
          last_name: 'Puim',
          type: 1,
          title: ''
        }
      },
      {
        id: 51,
        first_name: 'Nelson',
        last_name: 'Alba',
        email: 'Nelson.Alba@jcmincubator.com',
        employee: {
          id: 189,
          first_name: 'Nelson',
          last_name: 'Alba',
          type: 1,
          title: ''
        }
      },
      {
        id: 39,
        first_name: 'Pragnya',
        last_name: 'Mandala',
        email: 'pragnya.mandala@jcmincubator.com',
        employee: {
          id: 146,
          first_name: 'Pragnya',
          last_name: 'Mandala',
          type: 1,
          title: 'Business Analyst'
        }
      }
    ]
  },

  {
    id: 8,
    owner: 'Lamar Falconer',
    text: '<p>test @uid:3 </p>',
    created_at: '2023-11-01T17:15:10.912613Z',
    updated_at: '2023-11-01T17:15:10.912613Z',
    mentions: [
      {
        id: 3,
        first_name: 'Brandon',
        last_name: 'Puim',
        email: 'bpuim@altoleap.com',
        employee: {
          id: 157,
          first_name: 'Brandon',
          last_name: 'Puim',
          type: 1,
          title: ''
        }
      }
    ]
  }
];

export const mockWorkflowFormSubmissionsData = (): IWorkflowFormSubmissionData[] => [
  {
    id: 1,
    form: {
      id: 1,
      template: {
        id: 1,
        title: 'Workflow Onboarding',
        description: 'this is for workflow onboarding'
      },
      state: WorkflowFormTemplateStateEnum.Draft
    },
    answers: [
      {
        id: 1,
        value: 'MNadi',
        field: 2,
        option_submissions: []
      },
      {
        id: 2,
        value: 'grant',
        field: 4,
        option_submissions: []
      }
    ],
    created_at: '2023-03-17T19:54:36.647766Z',
    updated_at: '2023-03-17T19:54:36.647827Z'
  }
];

export const mockWorkflowFormSubmissions = (
  data: IWorkflowFormSubmissionData[] = mockWorkflowFormSubmissionsData()
): IWorkflowFormSubmission[] =>
  data.map(item => new WorkflowFormSubmission(item));

export const mockWorkflowFormSubmissionComments = (
  data: IWorkflowFormSubmissionCommentData[] = mockWorkflowFormSubmissionCommentsData()
): IWorkflowFormSubmissionComment[] =>
  data.map(comment => new WorkflowFormSubmissionComment(comment));
